import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {BranchesRequests} from "../../../branches/services/branches-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PoliciesAlertsService} from "../../../policies/services/policies-alerts.service";
import {BranchModel} from "../../../branches/models/branch.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {GroupModel} from "../../../groups/models/group.model";
import {PoliciesRequestsService} from "../../../policies/services/policies-requests.service";
import {GroupsDialogService} from "../../../groups/services/groups-dialog.service";

export class adminBranchesCtrl implements IController {
  user: any;
  branchIds: any;
  policyId: string;

  public siteId: string;
  public groupIds: string[];
  public groups: GroupModel[];
  public isBranchesView: boolean;

  /* @ngInject */
  constructor(private branchesDialogService: BranchesDialogService, private branchesRequests: BranchesRequests, private $branches, private splitService: SplitService,
              private confirmDialogService: ConfirmDialogService, private bringozLoaderService: BringozLoaderService, private policiesAlertsService: PoliciesAlertsService, private $log,
              private $groups, private policiesRequestsService: PoliciesRequestsService, private groupsDialogService: GroupsDialogService) {
  }

  $onInit() {
    this.siteId = this.splitService.getSiteId();

    if (!!this.user.groupIdsMap) {
      this.groupIds = this.user.groupIdsMap[this.siteId];
    }

    if (this.groupIds?.length) {
      this.isBranchesView = false;
      this.getGroups();
    } else {
      this.isBranchesView = true;
    }
  }

  onToggleView() {
    this.isBranchesView = !this.isBranchesView;
  }

  onAdd(event) {
    if (this.isBranchesView) {
      this.onAddBranch(event);
    } else {
      this.onAddGroup(event);
    }
  }

  onAddBranch(event) {
    this.branchesDialogService.branchSelect(event, this.branchIds)
      .then((branchId) => {
        this.bringozLoaderService.on();
        return this.$branches(branchId).$asyncValue();
      })
      .then((branch) => {
        return this.branchesRequests.addMembers(branch.id, [this.user.id]);
      })
      .then((updatedBranch) => {
        this.branchIds = _.union(this.branchIds, [updatedBranch.id]);
        this.policiesAlertsService.updateBranchesSuccess();
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateBranchesError();
          this.$log.error('Failed to add admin to branch', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onAddGroup(event) {
    this.groupsDialogService.addGroups(this.groupIds, true)
      .then((groupIds) => {
        this.onEditUserPolicyGroups(groupIds)
          .then((res) => {
            this.groupIds = groupIds;
            this.getGroups();
          })
      })
  }

  onRemoveBranch(branch: BranchModel, event) {
    this.confirmDialogService.confirm('Remove Branch', 'Are you sure you want to remove this branch?', event)
      .then(() => {
        this.bringozLoaderService.on();
        return this.branchesRequests.removeMembers(branch.id, [this.user.id]);
      })
      .then((updatedBranch) => {
        this.branchIds = _.without(this.branchIds, updatedBranch.id);
        this.policiesAlertsService.updateBranchesSuccess();
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateBranchesError();
          this.$log.error('Failed to remove admin from branch', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onRemoveGroup(group: GroupModel) {
    let groupToRemoveIndex = this.groups.findIndex(g => g.id === group.id);
    let groupsCopy = angular.copy(this.groups)
    this.confirmDialogService.confirm('Remove Group', 'Are you sure you want to remove this group?', event)
      .then(() => {
        this.bringozLoaderService.on();
        groupsCopy.splice(groupToRemoveIndex, 1);
        const groupIds = [group.id];
        return this.onRemoveUserPolicyBranchesAndGroups(undefined, groupIds);
      })
      .then((res) => {
        const groupsCopy = angular.copy(this.groups);
        groupsCopy.splice(groupToRemoveIndex, 1);
        this.groups = groupsCopy;
        this.groupIds = this.groups.map(g => g.id);
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateBranchesError();
          this.$log.error('Failed to remove admin from branch', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onEditUserPolicyGroups(groupIds: string[]) {
    return this.policiesRequestsService.editUserPolicyGroup(this.policyId, this.user.id, this.siteId, groupIds);
  }

  onRemoveUserPolicyBranchesAndGroups(branchIds?: string[], groupIds?: string[]) {
    return this.policiesRequestsService.removeUserPolicyBranchesAndGroups(this.policyId, this.user.id, this.siteId, branchIds, groupIds);
  }

  private getGroups() {
    this.$groups().$asyncValues(this.groupIds)
      .then((groups) => {
        this.groups = angular.copy(groups);
      })
  }

}

angular
  .module('bringoz.admin.admins')
  .component('adminBranches', {
    bindings: {
      user: '<',
      branchIds: '<',
      policyId: '<'
    },
    template: require('./admin-branches.html').default,
    controller: adminBranchesCtrl
  });
